import Vue from 'vue'

import VueScrollTo from 'vue-scrollto'
import InstantSearch from 'vue-instantsearch'
import { VueSpinners } from '@saeris/vue-spinners'
import { VTooltip } from 'v-tooltip'
import Toasted from 'vue-toasted'
import {
  duration,
  getBackgroundImg,
  getLearningPathBackground,
  getGradient,
} from '@/helpers'
import store from './store'
import router from './router'
import App from './App.vue'

require('./assets/js/jwplayer/jwplayer')
const marked = require('marked')

Vue.use(VueSpinners)
Vue.use(InstantSearch)
Vue.use(VueScrollTo)
Vue.use(Toasted)
Vue.toasted.register(
  'appError',
  payload => {
    if (!payload.message) {
      return 'Oops...Something Went Wrong..'
    }
    return payload.message
  },
  {
    type: 'error',
    iconPack: 'material',
    icon: 'error_outline',
    position: 'top-center',
    className: ['toast'],
    action: [
      {
        text: 'close',
        onClick: (e, toastObject) => {
          toastObject.goAway(0)
        },
      },
    ],
  }
)
Vue.toasted.register(
  'appNotification',
  payload => {
    return payload.message
  },
  {
    type: 'info',
    iconPack: 'material',
    icon: 'info',
    position: 'top-center',
    className: ['toast'],
    action: [
      {
        text: 'close',
        onClick: (e, toastObject) => {
          toastObject.goAway(0)
        },
      },
    ],
  }
)

Vue.directive('tooltip', VTooltip)
/* eslint-disable */
Vue.prototype.$jwplayer = jwplayer
Vue.prototype.$markdown = marked
/* eslint-enable */
Vue.prototype.$duration = duration
Vue.prototype.$getCourseBackground = getBackgroundImg
Vue.prototype.$getPlaylistBackground = getLearningPathBackground
Vue.prototype.$getGradient = getGradient
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
